import React from 'react';
import { SearchDialogAnalyticsContext } from '../analytics';
import { BUILD_VERSION } from '../../buildVersion';
export var BuildVersionAnalyticContext = function BuildVersionAnalyticContext(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(SearchDialogAnalyticsContext, {
    analyticContext: {
      frontend: BUILD_VERSION
    },
    nonPrivacySafeAnalyticContext: {}
  }, children);
};